import React from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { hideModal } from '../../redux/actions';
import text from '../../text';
import { Button } from '../button';
import Icon from '../icon/Icon';
import LinkButton from '../button/LinkButton';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const CONFIRM_MODAL = 'CONFIRM_MODAL';

const ConfirmModal = ({
  show,
  onConfirm,
  title,
  body,
  cancelLabel = text('cancel'),
  okLabel = text('ok'),
  isAttentionIconVisible,
  isFooterButtonReversed,
  isButtonFullWidth,
  isLinkButton,
  isCloseButtonVisible,
}) => {
  const dispatch = useDispatch();

  const onHide = () => dispatch(hideModal(CONFIRM_MODAL));

  const onOk = () => {
    onConfirm();
    onHide();
  };

  return (
    <Modal centered show={show} onHide={onHide}>
      <Modal.Header
        className='centered'
        {...(isCloseButtonVisible && { closeButton: true })}
      >
        <div className='d-flex flex-column align-items-center justify-content-center'>
          {isAttentionIconVisible ? (
            <Icon icon='circled-exclamation' className='mb-5' />
          ) : null}
          <h3>{title}</h3>
        </div>
      </Modal.Header>
      <Modal.Body className='text-center'>{body}</Modal.Body>
      <Modal.Footer
        className={classNames({
          'd-flex flex-fill flex-column-reverse': isFooterButtonReversed,
        })}
      >
        {isLinkButton ? (
          <LinkButton
            onClick={(e) => {
              e.preventDefault();
              onHide();
            }}
            className={classNames({
              'mt-3': isFooterButtonReversed,
            })}
          >
            {cancelLabel}
          </LinkButton>
        ) : (
          <Button
            variant='outline-primary'
            onClick={onHide}
            className={classNames({
              'mt-2': isFooterButtonReversed,
              'full-width': isButtonFullWidth,
            })}
          >
            {cancelLabel}
          </Button>
        )}

        <Button
          autoFocus
          onClick={onOk}
          className={classNames({
            'full-width': isButtonFullWidth,
          })}
        >
          {okLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

ConfirmModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  cancelLabel: PropTypes.string,
  okLabel: PropTypes.string,
  isAttentionIconVisible: PropTypes.bool,
  isFooterButtonReversed: PropTypes.bool,
  isButtonFullWidth: PropTypes.bool,
  isLinkButton: PropTypes.bool,
  isCloseButtonVisible: PropTypes.bool,
};

ConfirmModal.defaultProps = {
  cancelLabel: text('cancel'),
  okLabel: text('ok'),
  isAttentionIconVisible: false,
  isFooterButtonReversed: false,
  isButtonFullWidth: true,
  isLinkButton: false,
  isCloseButtonVisible: false,
};

export default ConfirmModal;
